import * as React from "react";
import { Plus } from "lucide-react";
import { cn } from "../utils/cn";
import { OrgAvatar } from "./OrgAvatar";
import { Pin } from "lucide-react";

export interface PinnedOrg {
    id: string;
    name: string;
    subtitle?: string;
    fallback: string;
}

export interface PinnedOrgsCardProps extends React.HTMLAttributes<HTMLDivElement> {
    orgs: PinnedOrg[];
    onAddClick?: () => void;
    onOrgClick?: (org: PinnedOrg) => void;
}

const PinnedOrgsCard = React.forwardRef<HTMLDivElement, PinnedOrgsCardProps>(
    ({ className, orgs, onAddClick, onOrgClick, ...props }, ref) => (
        <div ref={ref} className={cn("border-border bg-card flex flex-col rounded-2xl border", className)} {...props}>
            <div className="flex items-center justify-between px-5 pt-5 pb-4">
                <div className="flex items-center gap-2">
                    <Pin className="text-warning h-4 w-4 shrink-0" />
                    <h3 className="font-display text-foreground font-semibold">Pinned orgs</h3>
                </div>
                {onAddClick && (
                    <button
                        onClick={onAddClick}
                        className="border-border text-muted-foreground hover:text-foreground flex h-6 w-6 items-center justify-center rounded-md border transition-colors"
                    >
                        <Plus className="h-3.5 w-3.5" />
                    </button>
                )}
            </div>

            <div className="divide-border flex flex-col divide-y">
                {orgs.length === 0 && <div className="muted p-4 text-sm">No pinned organizations yet. </div>}
                {orgs.map((org) => (
                    <div
                        key={org.id}
                        className={cn(
                            "flex items-center gap-3 px-5 py-4",
                            onOrgClick && "hover:bg-muted/50 cursor-pointer transition-colors",
                        )}
                        onClick={() => onOrgClick?.(org)}
                    >
                        <OrgAvatar id={org.id} fallback={org.fallback} size="sm" />
                        <div className="min-w-0 flex-1">
                            <p className="font-display text-foreground truncate text-sm font-semibold">{org.name}</p>
                            {org.subtitle && <p className="text-muted-foreground truncate text-xs">{org.subtitle}</p>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    ),
);
PinnedOrgsCard.displayName = "PinnedOrgsCard";

export { PinnedOrgsCard };
